"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _RepositoryPrivateVisibilityOptions = require("../Shared/Models/RepositoryPrivateVisibilityOptions");
var _ProjectVisibility = require("../Shared/Models/ProjectVisibility");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var RepositoryOwnerPanelProjectVisibility = function RepositoryOwnerPanelProjectVisibility(props) {
  var privateProjectVisibility = false;
  if (props.projectVisibility === _ProjectVisibility.ProjectVisibility.Private) {
    privateProjectVisibility = true;
  }
  if (privateProjectVisibility) {
    return /*#__PURE__*/React.createElement(_react2.Stack, {
      tokens: {
        childrenGap: 8
      }
    }, /*#__PURE__*/React.createElement(_react2.Text, {
      as: "h2",
      id: "project-visibility-title",
      variant: "xLarge"
    }, t("repositoryOwnerPanel.visibility.title")), /*#__PURE__*/React.createElement(_react2.ChoiceGroup, {
      name: "projectVisibility",
      selectedKey: props.repositoryPrivateVisibilityOptions,
      onChange: function onChange(ev, option) {
        option && props.setRepositoryPrivateVisibilityOptions(option.key);
      },
      options: [{
        key: _RepositoryPrivateVisibilityOptions.RepositoryPrivateVisibilityOptions.NameAllowed,
        ariaLabel: t("repositoryOwnerPanel.visibility.repositoryNameAllowed"),
        text: t("repositoryOwnerPanel.visibility.repositoryNameAllowed")
      }, {
        key: _RepositoryPrivateVisibilityOptions.RepositoryPrivateVisibilityOptions.NameNotAllowed,
        ariaLabel: t("repositoryOwnerPanel.visibility.repositoryNameNotAllowed"),
        text: t("repositoryOwnerPanel.visibility.repositoryNameNotAllowed")
      }]
    }));
  }
  return null;
};
var _default = RepositoryOwnerPanelProjectVisibility;
exports.default = _default;